import './polyfills';

import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { TitleTextPipe } from '@app/shared/pipes/title-text.pipe';
import { Title, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { TimerResetInterceptor } from './app/core/services/timerResetInterceptor';
import { appRoutes } from './app/app-routing.module';
import { SecurityModule } from './app/security/security.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ClientConfigModule } from './app/client-config/client-config.module';
import { TwoWayModule } from '@app/two-way/two-way.module';
import { CoreModule } from './app/core/core.module';
import { LauncherModule } from './app/launcher/launcher.module';
import { CustomerListModule } from './app/customer/customer.module';
import { CxBuilderModule } from './app/cx-builder/cx-builder.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { JourneyListModule } from './app/journey-list/journey-list.module';
import { JobsListModule } from '@app/jobs-list/jobs-list.module';
import { MediaLibraryModule } from './app/media-library/media-library.module';
import { NavigationModule } from './app/navigation/navigation.module';
import { PreviewModule } from './app/preview/preview.module';
import { RelaySharedModule } from './app/shared/shared.module';
import { UserModule } from './app/user/user.module';
import { SftpMgmtModule } from '@app/sftp-mgmt/sftp-mgmt.module';
import { ShortcodeMgmtModule } from '@app/shortcode-mgmt/shortcode-mgmt.module';
import { ApiMgmtModule } from './app/api-mgmt/api-mgmt.module';
import { NotificationThrottlingModule } from './app/notification-throttling/notification-throttling.module';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(appRoutes),
        importProvidersFrom(SecurityModule, FormsModule, BrowserModule, ClientConfigModule, TwoWayModule, CoreModule, LauncherModule, ReactiveFormsModule, CustomerListModule, CxBuilderModule, FormsModule, InfiniteScrollModule, JourneyListModule, JobsListModule, LauncherModule, LauncherModule, MediaLibraryModule, NavigationModule, PreviewModule, ReactiveFormsModule, RelaySharedModule, SecurityModule, UserModule, SftpMgmtModule, ShortcodeMgmtModule, ApiMgmtModule, NotificationThrottlingModule),
        provideHttpClient(withInterceptorsFromDi()),
        DatePipe,
        TitleTextPipe,
        Title,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TimerResetInterceptor,
            multi: true,
        },
        provideAnimations(),
    ]
});
